export const DUPLICATE_TAG_ERROR_MESSAGE =
  'There is already a Tag with this name for this category';
